import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { HTTPService, HTTPServiceError, HTTPRequestType, JsonResultClass } from "../core/util/httpManager";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class UpdateApplicationApp extends React.Component<UpdateApplicationAppProps, any> {
    private _uploadInputRef = null;
    private _uploadCustomInputRef = null;
    private _uploadRef: kendo.ui.Upload = null;
    private _uploadCustomRef: kendo.ui.Upload = null;
    private _contentRef = null;
    private _updateFile = null;
    private _updateCustomFile = null;
    private _progressElemRef = null;
    private _progressRef: kendo.ui.ProgressBar = null;
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string> = null;
    uploadEnabled = false;
    uploadOptions: kendo.ui.UploadOptions = null;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    private _doOnSelect = (kendoEvent: kendo.ui.UploadSelectEvent) => {
        const file = kendoEvent.files[0];
        const validUpload = Helper.hasValue(file) && file.extension.toLowerCase() === ".zip";
        const isStd = kendoEvent.sender["name"] === "updateFile";

        $(".k-upload-action.k-button.k-button-bare", $("#" + (isStd ? "std-zip-upload" : "custom-zip-upload"))).trigger("click");


        if (validUpload) {
            this.uploadEnabled = true;
            if (isStd) {
                this._updateFile = file;
            } else {
                this._updateCustomFile = file;
            }
        } else {
            if (isStd) {
                this._updateFile = null;
            } else {
                this._updateCustomFile = null;
            }
            this.uploadEnabled = Helper.hasValue(this._updateFile) || Helper.hasValue(this._updateCustomFile);
            NotificationHelper.showWarningMessage(this.translations["WebSMS.UpdateApplication.LoadValidFile"]);
            kendoEvent.files.pop();
            kendoEvent.preventDefault();
            $(".k-upload-action.k-button.k-button-bare", $("#" + (isStd ? "std-zip-upload" : "custom-zip-upload"))).trigger("click");
        }
        this.setState({});
    }

    renderUpload = () => {
        return (
            <div style={{ maxWidth: 400, marginLeft: 10 }}>
                <div id="std-zip-upload" style={{ marginTop: "20px" }}><label>{this.translations["WebSMS.UpdateApplication.AppFile"]}: <input name='updateFile' type='file' ref={r => this._uploadInputRef = r} /></label></div>
                <div id="custom-zip-upload" style={{ marginTop: "20px" }}><label>{this.translations["WebSMS.UpdateApplication.CustomFile"]}: <input name='cusUpdateFile' type='file' ref={r => this._uploadCustomInputRef = r} /></label></div>
                <div style={{ marginTop: "20px", visibility: this.uploadEnabled ? null : "hidden" }}>
                    <label>{this.translations["WebSMS.UpdateApplication.UploadProcess"]}:</label>
                    <div style={{ width: "100%" }} ref={(r) => { this._progressElemRef = r }}></div>
                </div>
            </div>
        );
    }

    upload = () => {
        if (this._updateFile !== null || this._updateCustomFile !== null) {
            const formData = new FormData();
            if (this._updateFile) {
                formData.append("updateZip", this._updateFile.rawFile);
            }
            if (this._updateCustomFile) {
                formData.append("cusUpdateZip", this._updateCustomFile.rawFile);
            }
            NotificationHelper.showInfoMessage(this.translations["WebSMS.UpdateApplication.UpdateInProgress"], { timeOut: 0 });
            HTTPService.withProgress(percentage => {
                this._progressRef.value(Math.ceil(percentage));
            }).post<JsonResultClass>("UpdateApplication/Upload", formData)
                .then(result => {
                    if (result.Code === 1) {
                        NotificationHelper.showErrorMessage(result.Message);
                    } else {
                        Helper.setBusyIndicator(true).then(_ => {
                            setTimeout(() => {
                                window.location.href = Config.baseUrl;
                            }, 1500);
                        });
                    }
                }, (r: HTTPServiceError) => {
                    //file too big
                    if (r.status === 404) {
                        NotificationHelper.clearMessages();
                        NotificationHelper.showErrorMessage("Error updating the application. Please check that the zip file does not exceed the maximum configured size.");
                    } else {
                        NotificationHelper.showErrorMessage("Error updating application.");
                    }
                });
        }
    }

    componentDidMount() {
        this.uploadOptions.select = this._doOnSelect;
        this.uploadOptions.remove = (kendoEvent) => {
            const isStd = kendoEvent.sender["name"] === "updateFile";

            if (isStd) {
                this._updateFile = null;
            } else {
                this._updateCustomFile = null;
            }
            this.uploadEnabled = Helper.hasValue(this._updateFile) || Helper.hasValue(this._updateCustomFile);

            this.setState({});
        }
        this._uploadRef = $(this._uploadInputRef).kendoUpload(this.uploadOptions).data("kendoUpload");
        this._uploadCustomRef = $(this._uploadCustomInputRef).kendoUpload(this.uploadOptions).data("kendoUpload");
        this._progressRef = $(this._progressElemRef).kendoProgressBar({ type: "percent", animation: false } as any).data("kendoProgressBar");
    }

    render() {
        if (this.props.debugModeOn) {
            return (
                <div style={{ margin: "15px" }}>
                    <span style={{ fontSize: "medium" }}>
                        {this.translations["WebSMS.UpdateApplication.InDebugMode"]}
                    </span>
                </div>
            );
        } else {
            const props = $.extend({}, this.props, this.common.getHandlersForProps());
            return <CommonApp {...props} />;
        }
    }
}

export interface UpdateApplicationAppProps extends AppBaseProps {
    debugModeOn?: true;
}